import { useTranslation } from 'react-i18next';

export interface TaskExecutorFlagsValue {
    reserveExecutorTime: boolean;
    executorCanChangeTerm: boolean;
    noEarlyStart: boolean;
}

interface TaskExecutorFlagsProps {
    idPrefix: string;
    value: TaskExecutorFlagsValue;
    disabled?: boolean;
    onChange: (next: TaskExecutorFlagsValue) => void;
}

const TaskExecutorFlags = ({ idPrefix, value, disabled = false, onChange }: TaskExecutorFlagsProps) => {
    const { t } = useTranslation(['Tasks']);
    const reserveId = `${idPrefix}-reserve-executor-time`;
    const changeTermId = `${idPrefix}-executor-can-change-term`;
    const noEarlyStartId = `${idPrefix}-no-early-start`;

    return (
        <>
            <div className="form-check form-switch mb-3">
                <input
                    type="checkbox"
                    className="form-check-input"
                    role="switch"
                    id={reserveId}
                    checked={value.reserveExecutorTime}
                    disabled={disabled}
                    onChange={(e) => onChange({ ...value, reserveExecutorTime: e.target.checked })}
                />
                <label className="form-check-label" htmlFor={reserveId}>
                    <span className="d-block">{t('labelReserveExecutorTime')}</span>
                    <span className="d-block text-muted fs-12">{t('hintReserveExecutorTime')}</span>
                </label>
            </div>
            <div className="form-check form-switch mb-3">
                <input
                    type="checkbox"
                    className="form-check-input"
                    role="switch"
                    id={changeTermId}
                    checked={value.executorCanChangeTerm}
                    disabled={disabled}
                    onChange={(e) => onChange({ ...value, executorCanChangeTerm: e.target.checked })}
                />
                <label className="form-check-label" htmlFor={changeTermId}>
                    <span className="d-block">{t('labelExecutorCanChangeTerm')}</span>
                    <span className="d-block text-muted fs-12">{t('hintExecutorCanChangeTerm')}</span>
                </label>
            </div>
            <div className="form-check form-switch mb-3">
                <input
                    type="checkbox"
                    className="form-check-input"
                    role="switch"
                    id={noEarlyStartId}
                    checked={value.noEarlyStart}
                    disabled={disabled}
                    onChange={(e) => onChange({ ...value, noEarlyStart: e.target.checked })}
                />
                <label className="form-check-label" htmlFor={noEarlyStartId}>
                    <span className="d-block">{t('labelNoEarlyStart')}</span>
                    <span className="d-block text-muted fs-12">{t('hintNoEarlyStart')}</span>
                </label>
            </div>
        </>
    );
};

export default TaskExecutorFlags;
